(function($){
  $(function(){

    console.log('> init!');

    AOS.init({
      once: true,
      offset: -100
    });

    $(document).on('click', '.shogun-accordion-heading', function(){
      
      console.log('> clicked!');
      
      $(this).parent('.shogun-accordion').find('.shogun-accordion-body').slideToggle();
      $(this).parent('.shogun-accordion').toggleClass('shogun-accordion-active');
      $(this).parent('.shogun-accordion').find('.shogun-accordion-body').toggleClass('shogun-accordion-active');
    })


    $('.scm-button-submit').on('click', function(){
      $('.scm-button-submit').addClass('disabled');
    })
      
    
  });
})(jQuery);